import { onMounted, onUnmounted } from "vue";

/**
 * Custom hook to handle user inactivity and sign out after a specified period.
 */
export function useInactivitySignOut(onSignOut: () => void, isSignedIn: () => boolean) {
    let inactivityTimeout: ReturnType<typeof setTimeout> | null = null;
    const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes

    function resetInactivityTimer() {
        if (inactivityTimeout) clearTimeout(inactivityTimeout);
        inactivityTimeout = setTimeout(() => {
            onSignOut();
        }, INACTIVITY_LIMIT);
    }

    function setupInactivityListeners() {
        const events = ["mousemove", "keydown", "mousedown", "touchstart"];
        events.forEach((event) => {
            window.addEventListener(event, resetInactivityTimer);
        });
        resetInactivityTimer();
    }

    function removeInactivityListeners() {
        const events = ["mousemove", "keydown", "mousedown", "touchstart"];
        events.forEach((event) => {
            window.removeEventListener(event, resetInactivityTimer);
        });
        if (inactivityTimeout) clearTimeout(inactivityTimeout);
    }

    onMounted(() => {
        if (isSignedIn()) {
            setupInactivityListeners();
        }
    });

    onUnmounted(() => {
        removeInactivityListeners();
    });
}
